<template>
  <div ref="viewer"></div>
</template>

<script>
  /* eslint-disable */
  import WebViewer from '@pdftron/pdfjs-express-viewer'

  export default {
    name: 'WebViewer',
    props: {
      path: String
    },
    data() {
      return {
        pathUrl: '',
        searchTerm: '',
        pageNum: 1
      }
    },
    mounted() {
      const me = this
      me.pathUrl = window.localStorage.getItem('pathUrl')
      me.searchTerm = window.localStorage.getItem('searchTerm')
      me.pageNum = parseInt(window.localStorage.getItem('pageNum'))
      WebViewer(
        {
          path: '/dist/static/pdfjsexpress',
          initialDoc: me.pathUrl,
          licenseKey: process.env.PDFJSEXPRESS_LICENCE_KEY
        },
        this.$refs.viewer
      ).then((instance) => {
        // now you can access APIs through the WebViewer instance
        const { Core, UI } = instance
        // const { documentViewer, Core, annotationManager, Annotations } =
        const { documentViewer, annotationManager, Annotations } = instance.Core

        // Core.documentViewer.addEventListener('documentLoaded', () => {
        documentViewer.addEventListener('documentLoaded', () => {
          const searchValue = me.searchTerm

          // set the ui language to pt_BR
          instance.UI.setLanguage('pt_br');

          // instance.UI.searchText(searchValue) // search on page
          instance.UI.searchTextFull(searchValue)
        })

        Core.documentViewer.addEventListener(
          'activeSearchResultChanged',
          () => {
            Core.documentViewer.setCurrentPage(me.pageNum)
          }
        )

        // adding an event listener for when the page number has changed
        Core.documentViewer.addEventListener(
          'pageNumberUpdated',
          (pageNumber) => {
            //
          }
        )

        // adds a button to the header that on click sets the page to the next page
        UI.setHeaderItems((header) => {
          header.push({
            type: 'actionButton',
            img: 'https://icons.getbootstrap.com/assets/icons/caret-right-fill.svg',
            onClick: () => {
              const currentPage = Core.documentViewer.getCurrentPage()
              const totalPages = Core.documentViewer.getPageCount()
              const atLastPage = currentPage === totalPages

              if (atLastPage) {
                Core.documentViewer.setCurrentPage(1)
              } else {
                Core.documentViewer.setCurrentPage(currentPage + 1)
              }
            }
          })
        })
      })
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  div {
    width: 100%;
    height: 100vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/VerEdicao.vue